module.exports = __webpack_public_path__ + "img/res01.95041bb2.png";